import { createContext, useContext, useState } from 'react'

export const NavigationContext = createContext()

const NAVIGATION_OPTIONS = {
  HOME: 1,
  DISCOVER_ONE: 2,
  DISCOVER_TWO: 3,
  DISCOVER_THREE: 4,
  PLAY: 5,
}

/**
 *
 * @returns { navigation, setNavigation, NAVIGATION_OPTIONS }
 */
export const useNavigationContext = () => useContext(NavigationContext)

export const NavigationContextProvider = ({ children }) => {
  const [navigation, setNavigation] = useState(NAVIGATION_OPTIONS.HOME)

  const value = { navigation, setNavigation, NAVIGATION_OPTIONS }
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  )
}
